import styled from "styled-components";

const SectionSubheading = styled.div`
  color: #546E7A;
  font-size: 24px;
`;

export default SectionSubheading;
